import { ADD_COUNTER_ONE, ADD_COUNTER_TWO } from './type';

export const addCounterOne = () => ({ type: ADD_COUNTER_ONE });
export const addCounterTwo = () => ({ type: ADD_COUNTER_TWO });
